export class LazyBackground {
    private readonly elements: NodeListOf<Element>;
    public selector: string;

    constructor(selector: string) {
        this.elements = document.querySelectorAll(`.${selector}`);
        this.selector = selector;
        this.init();
    }

    public load(): void {
        if ("IntersectionObserver" in window) {
            const imageObserver = new IntersectionObserver((entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const
                            image = entry.target as HTMLElement,
                            src = image.getAttribute(`data-src`);
                        if (src) image.style.backgroundImage = src;
                        imageObserver.unobserve(image);
                    }
                });
            });

            this.elements.forEach((image) => {
                imageObserver.observe(image);
            });
        } else {
            this.elements.forEach((image: HTMLElement) => {
                const src = image.getAttribute(`data-src`);
                if (src) image.style.backgroundImage = src;
            });
        }
    }

    protected init(): void {
        if (!this.elements.length) return;
        this.load();
    }
}